import axios from 'axios';

const fetcher = async (
  url: string,
  query?: { params: { [k: string]: string } },
  fullResponse?: boolean,
) => await axios.get(url, query ?? undefined).then((res) => (fullResponse ? res : res.data));

export default fetcher;
